<template>
  <section v-if="visible" class="rotation" aria-labelledby="rotation-heading" :data-selected-item-rotation="selectedItemRotation" :data-grid-item-rotation="gridItemRotation">
    <h2 id="rotation-heading">ROTATION</h2>
    <label><input aria-label="Shape rotation" type="number" min="-360" max="360" :value="currentRotation" @change="changeShapeRotation"><span>Deg</span></label>
  </section>
</template>

<script setup lang="ts">
import { shouldShowRotationControl } from '~/composables/shapes/shapeCapabilities'

const gridStore = useGridStore()
const { selectedItemsOnGrid, selectedRotation, selectedShape } = storeToRefs(gridStore)
const { changeShapeRotation } = useShapeInteractions()
const visible = computed(() => shouldShowRotationControl({
  selectedShape: selectedShape.value,
  selectedItems: selectedItemsOnGrid.value,
}))
const currentRotation = computed(() => selectedItemsOnGrid.value[0]?.rotation ?? selectedRotation.value ?? selectedShape.value?.rotation ?? 0)
const selectedItemRotation = computed(() => selectedItemsOnGrid.value[0]?.rotation ?? '')
const gridItemRotation = computed(() => {
  const selectedId = selectedItemsOnGrid.value[0]?.id
  return selectedId ? gridStore.shapeList.find(item => item.id === selectedId)?.rotation ?? '' : ''
})
</script>

<style scoped>
h2 { margin: 0; color: #95948f; font-size: 13px; font-weight: 800; letter-spacing: .08em; }
.rotation { margin-top: 24px; }
label { display: flex; width: 80px; height: 39px; margin-top: 13px; overflow: hidden; border: 1px solid #deddd9; border-radius: 7px; }
input { width: 46px; border: 0; text-align: center; font: inherit; font-size: 12px; font-weight: 700; }
span { display: grid; flex: 1; place-items: center; background: #e5e4e0; color: #74736f; font-size: 12px; }
</style>
